<h1>{{ 'general.errors.page-not-found.title' | translate }}</h1>

<p>
	{{ 'general.errors.page-not-found.message' | translate }}
	<br><br>
	<a routerLink="/home">
		{{ 'general.errors.page-not-found.go-back-home' | translate }}
	</a>
</p>